import { clearMessage } from "../messages/actions";
import { connect } from "react-redux";
import MessageComponent from "../components/MessageComponent";
const mapStateToProps = state => {
  return {
    message: state.messages.message,
    type: state.messages.type
  };
};

const mapDispatchToProps = dispatch => {
  return {
    clear: () => {
      dispatch(clearMessage());
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MessageComponent);



// WEBPACK FOOTER //
// ./src/containers/MessageWrapper.js